import rootStore from "../index"
import ApiService from "../../services/api.service";
import {TokenService} from "../../services/storage.service";
import apiService from "../../services/api.service";

const state = {
    defaultKilometer : 100,
    default_v_t : 1,
    kilometerRange : [
        {text : 'All', value : 100},
        {text : '10 km', value : 10},
        {text : '20 km', value : 20},
        {text : '30 km', value : 30},
        {text : '50 km', value : 50}
    ],
    kilometerRange_fi : [
        {text : 'Kaikki', value : 100},
        {text : '10 km', value : 10},
        {text : '20 km', value : 20},
        {text : '30 km', value : 30},
        {text : '50 km', value : 50}
    ],
    vehicle_types : [{ text: "All", value: 1 }, { text: "Car", value: 2 } , { text: "Van", value: 3 }],
    vehicle_types_fi : [{ text: "Kaikki", value: 1 }, { text: "Henkilöauto", value: 2 } , { text: "Pakettiauto", value: 3 }],
    sortingTitles : ["From nearest", "From farthest", "Name A -Ö", "Name Ö-A"],
    sortingTitles_fi : ["Lähimmästä", "Kauvimmasta", "Nimi A-Ö", "Nimi Ö-A"],
    sortingOptions : [
        {text : "From nearest", value : 0},
        {text : "From farthest", value : 1},
        {text : "Name A -Ö", value : 2},
        {text : "Name Ö-A", value : 3},
    ],
    sortingOptions_fi : [
        {text : "Lähimmästä", value : 0},
        {text : "Kauvimmasta", value : 1},
        {text : "Nimi A-Ö", value : 2},
        {text : "Nimi Ö-A", value : 3},
    ],
    defaultSort : 0,
    sbspLoader : false,
    showServices : false,
    address : ""

}

const getters = {
    defaultKilometer : (state) =>state.defaultKilometer,
    default_v_t : (state) =>state.default_v_t,
    kilometerRange : (state) =>state.kilometerRange,
    kilometerRange_fi : (state) =>state.kilometerRange_fi,
    vehicle_types : (state) =>state.vehicle_types,
    vehicle_types_fi : (state) =>state.vehicle_types_fi,
    sortingTitles : (state) =>state.sortingTitles,
    sortingTitles_fi : (state) =>state.sortingTitles_fi,
    sortingOptions : (state) =>state.sortingOptions,
    sortingOptions_fi : (state) =>state.sortingOptions_fi,
    sbspLoader : (state) =>state.sbspLoader,
    showServices : (state) =>state.showServices,
    defaultSort : (state) =>state.defaultSort,
    address : (state) =>state.address,
}

const actions = {
    setLoading({commit}, bool) {
        commit("setLoading", bool)
    },
    setShowServices({commit}, bool) {
        commit("setShowServices", bool)
    },
    setDefaultSort({commit}, bool) {
        commit("setDefaultSort", bool)
    },
    setDefaultKilometer({commit}, val) {
        commit("setDefaultKilometer", val)
    },
    setDefaultVT({commit}, val) {
        commit("setDefaultVT", val)
    },
    setAddress({commit}, address) {
        commit("setAddress", address)
    },
    async searchServicePoints({commit, state, rootState}) {
        if (!("GoogleAddress" in localStorage)) {
            return;
        }

        commit("setLoading", true)
        let params= '';
        const Address = localStorage.getItem('GoogleAddress');
        let addressCoordinates = (Address) ? JSON.parse(Address) : null
        if(addressCoordinates && addressCoordinates.latitude) {
            params = 'latitude=' + addressCoordinates.latitude
        }
        if(addressCoordinates && addressCoordinates.longitude) {
            params = params + '&longitude=' + parseFloat(addressCoordinates.longitude).toFixed(8)
        }

        let locale_code = (rootState.app.currentLang == '') ? 'fi_FI' : rootState.app.currentLang
        let locale_id = (locale_code == 'en_GB') ? 1 : 2
        params = params + '&locale_id='+ locale_id
        params = params + '&with=["timeSlots","workingDays"]'
        params = params + '&search_radius='+state.defaultKilometer
        params = params + '&vehicle_type='+state.default_v_t

        await rootStore.dispatch("search_dealer/fetchDealers",  params, {root : true}).finally(() => {
            commit("setLoading", false)
            commit("sortSearchedServicePoints", rootState.search_dealer.service_points)
        })

        rootStore.dispatch("search_dealer/setSearchedZipcode", state.address, {root : true});
        commit("setShowServices", true)
    },
    sortSearchedServicePoints({commit, state, rootState}) {
        commit("sortSearchedServicePoints", rootState.search_dealer.service_points)
    },
    setDefaultServicePoint({rootState}) {
        if (rootState.search_dealer.service_points.length && "SearchedSelectedServicePoint" in localStorage) {
            const savedServicePointName = (JSON.parse(localStorage.getItem("SearchedSelectedServicePoint"))).company_name;
            const selected = rootState.search_dealer.service_points.find((ServicePoint) => {return ServicePoint.company_name == savedServicePointName})
            if (selected) {
                rootStore.dispatch("search_dealer/setSelectedServicePoint", selected, {root : true})
            }
        }
    },
    async removeOlderAppointment() {
        var token = TokenService.getToken(), anonymousId = "", ApiResource = null, service_point_id = null;
        if ("SearchedSelectedServicePoint" in localStorage) {
            service_point_id = JSON.parse(localStorage.getItem("SearchedSelectedServicePoint")).dealer_id;
        }

        return new Promise((resolve, reject) => {
            if (token) {
                ApiResource = apiService.delete('/customer/appointment/remove/'+service_point_id, { 'headers': { 'token': token} });
            } else {
                if(!TokenService.getGuestToken()) {
                    TokenService.setGuestToken()
                }
                anonymousId = TokenService.getGuestToken();
                ApiResource = ApiService.delete('/anonymous/appointment/remove/'+service_point_id, { params : {anonymous_id : anonymousId}});
            }

            ApiResource.then(() => {
                resolve();
            }).catch(error => {
                reject(error);
            })
        })
    }
}

const mutations = {
    setLoading(state, bool) {
        state.sbspLoader = bool
    },
    setDefaultSort(state, bool) {
        state.defaultSort = bool
    },
    setShowServices(state, bool) {
        state.showServices = bool
    },
    setDefaultKilometer(state, val) {
        state.defaultKilometer = val
    },
    setDefaultVT(state, val) {
        state.default_v_t = val
    },
    setAddress(state, address) {
        state.address = address
    },
    sortSearchedServicePoints(state, service_points) {
        let data = null;
        switch(state.defaultSort) {
            case 0:
                data = service_points.sort((a, b) => {return parseFloat(a.distance_km).toFixed(2) - parseFloat(b.distance_km).toFixed(2)})
                break;
            case 1:
                data = service_points.sort((a, b) => {return parseFloat(b.distance_km).toFixed(2) - parseFloat(a.distance_km).toFixed(2)})
                break;
            case 2:
                data = service_points.sort((a, b) => {return ((a.company_name == b.company_name) ? 0 : ((a.company_name > b.company_name) ? 1 : -1))})
                break;
            case 3:
                data = service_points.sort((a, b) => {return ((a.company_name == b.company_name) ? 0 : ((a.company_name < b.company_name) ? 1 : -1))})
                break;
        }
        rootStore.dispatch("search_dealer/setDealers", data, {root : true})
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}